<template>
    <validation-observer id="form">
        <v-card
            :loading="settingsLoading"
            class="SettingCard"
        >
            <v-card-title>
                <slot name="title" />
            </v-card-title>
            <v-card-text>
                <slot name="form" />
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    :form="form"
                    type="submit"
                    color="primary"
                >
                    <v-icon
                        small
                        left
                    >
                        fas fa-save
                    </v-icon>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </validation-observer>
</template>

<script>
export default {
    props: {
        settingsLoading: {
            type: Boolean,
            required: true,
        },

        form: {
            type: String,
            required: true,
        }
    },

    computed: {
        routePage() {
            return this.$router.currentRoute.name;
        }
    },
};
</script>
<style lang="scss">
.SettingGroup__heading {
    font-size: 1rem !important;
    margin-bottom: 18px !important;
}

.SettingRow__heading {
    font-size: 0.9rem !important;
    margin-bottom: 8px !important;
}

.SettingCard {
    margin-bottom: 24px ;
}

</style>
